import useNav from './useNav';
import { useBaseParam } from './useBaseParam';
import { fetchSelectTempPreRequest } from '../../infra/api/mtg/fetchSelectTempPreRequst';
import { useRecoilState } from 'recoil';
import * as Atom from '../recoil';

export const useReuseBottomSheet = () => {
  // navigate
  const { navigate } = useNav();
  const navigateMtgStep = (step?: number) => {
    navigate(`/mtg/conditions/${step || 1}`);
  };

  // reuse setting
  const [personal] = useRecoilState(Atom.personalInfo);
  const [, setMortgage] = useRecoilState(Atom.mortgageInfo);
  const [commonCodes] = useRecoilState(Atom.commonCodes);
  const getReuseInfo = useBaseParam(fetchSelectTempPreRequest, {
    custSeq: personal.custSeq,
  });

  const convertToPyoung = (dedicatedArea: string) => {
    if (!dedicatedArea)
      return "0";

    const num = Number(dedicatedArea.replace(/[^0-9\.]/g, ''));
    if (isNaN(num))
      return "0";
      
    return (num / 3.3).toFixed(0);
  }
  
  const setReuseInfo = async () => {
    const response = await getReuseInfo();
    const reusedInfo = Atom.resetAmtUnit({
      ...response.data.result.tempResult,
    });

    const jobs = commonCodes[1]?.list.map((item: any) => {
      return { label: item.codeNm, value: item.code };
    });
    setMortgage(() => {
      return {
        ...reusedInfo,
        purposeCd: {
          value: reusedInfo.purposeCd ?? '',
          text: reusedInfo.purposeCdNm ?? '',
        },
        haveCnt: { value: reusedInfo.haveCnt ?? '', text: reusedInfo.haveCntNm  ?? ''},
        houseType: {
          value: reusedInfo.houseType ?? '',
          text: reusedInfo.houseTypeNm ?? '',
        },
        apartment: { value: reusedInfo.apartment ?? '', text: reusedInfo.areaName ?? ''}, // 물건 이름, 물건 코드
        ldongCode: { value: reusedInfo.ldongCode ?? '', text: reusedInfo.ldongCode ?? ''}, // 법정동 이름, 법정동 코드
        rateSeq: {value: reusedInfo.rateSeq ?? '', text: reusedInfo.dedicatedArea ? `${convertToPyoung(reusedInfo.dedicatedArea)}평(${reusedInfo.dedicatedArea})` : ''}, // 물건 순번 코드, 평형 정보
        floor: { value: reusedInfo.floor ?? '', text: reusedInfo.floorNm  ?? ''},
        address: reusedInfo.areaName ?? '',
        previousYn: {
          value: reusedInfo.previousYn ?? '',
          text: reusedInfo.previousYn ? (reusedInfo.previousYn === 'Y' ? '대출금이 있어요' : '대출금이 없어요') : '',
        },
        tenantYn: {
          value: reusedInfo.tenantYn ?? '',
          text: reusedInfo.tenantYn ? (reusedInfo.tenantYn === 'Y' ? '세입자가 있어요' : '세입자가 없어요') : '',
        },
        marriageCd: {
          value: reusedInfo.marriageCd ?? '',
          text: reusedInfo.marriageCdNm ?? '',
        },
        jobType: { value: reusedInfo.jobType, text: jobs.find((item:any) => item.value === reusedInfo.jobType)?.label },
        openDt: { value: reusedInfo.openDt ?? '', text: reusedInfo.openDt ?? '' },
        firstYn: {
          value: reusedInfo.firstYn ?? '',
          text: reusedInfo.firstYn ? (reusedInfo.firstYn === 'Y' ? '첫 구매에요' : '첫 구매라면 대출한도가 높아질 수 있어요') : '',
        },
        disposalPlanYn: {
          value: reusedInfo.disposalPlanYn ?? '',
          text: reusedInfo.disposalPlanYn ? (reusedInfo.disposalPlanYn === 'Y' ? '처분 계획 있어요' : '처분 계획 없어요') : '',
        },
        isRegulation: reusedInfo.isRegulation ?? false,
        housePrice: reusedInfo.saleGeneralAverage ? reusedInfo.saleGeneralAverage : (reusedInfo.houseAmt ?? ''),
      };
    });
    let step;
    if (!reusedInfo.purposeCd) {
      step = 1;
    } else if (!reusedInfo.haveCnt) {
      step = 2;
    } else if (!reusedInfo.hopefulAmt) {
      step = 3;
    } else if (!reusedInfo.tenantYn) {
      step = 4;
    } else if (!reusedInfo.salaryAmt) {
      step = 5;
    } else if (!reusedInfo.credPoint) {
      step = 6;
    } else {
      step = 7;
    }
    navigateMtgStep(step);
  };

  return {
    navigateMtgStep,
    setReuseInfo,
  };
};
